module.exports = __webpack_public_path__ + "static/bilxtrahjelpstor1-6ae5526cc7d2d7489fd07368fbc82f20.png";